import { render, staticRenderFns } from "./ociBreadcrumb.vue?vue&type=template&id=1f379927&"
import script from "./ociBreadcrumb.vue?vue&type=script&lang=js&"
export * from "./ociBreadcrumb.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports